import { render, staticRenderFns } from "./styling.vue?vue&type=template&id=24221886&scoped=true&"
import script from "./styling.vue?vue&type=script&lang=js&"
export * from "./styling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24221886",
  null
  
)

export default component.exports